import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'kv-point-transfer-dialog',
  template: `
    <div class="ui-dialog-content ui-g-12">
      <form [formGroup]="balanceForm" (submit)="onConfirmTransfer()">
        <div [kv-form-element]="{ label: 'common.balance', md: '12'}">
          <input pInputText formControlName="balanceTransfer" type="number" min="0" max="{{this.maxPoint}}" />
          {{'(max: ' + maxPoint + ')'}}
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button [disabled]="!balanceForm.valid" pButton type="submit" class="buttonExpand k-generic-btn" [label]="'common.confirm' | translate" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </form>
    </div>
  `
})
export class PointTransferDialogComponent implements OnChanges{
  @Input() maxPoint: number;
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();

  balanceForm: FormGroup;



  constructor(
    private fb: FormBuilder

  ) {


  }
  onConfirmTransfer() {
    this.onConfirm.emit(this.balanceForm.value['balanceTransfer'])
  }

  ngOnChanges(changes: SimpleChanges): void {
    let _maxPoint = 999
    if (changes['maxPoint'] && changes['maxPoint'].currentValue)
      _maxPoint = changes['maxPoint'].currentValue

    this.balanceForm = this.fb.group({
      balanceTransfer: new FormControl(this.maxPoint, Validators.compose([ Validators.required, Validators.max(_maxPoint),Validators.min(1)]))
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/point-transfer-dialog.component.ts